import validate from "/app/node_modules/.pnpm/nuxt@4.6.4_0e13fd5257b8dba9d4e17f718301a864/node_modules/nuxt/dist/pages/runtime/validate.js";
import legacy_45order_45redirect_45global from "/app/apps/cue-subclient/app/middleware/legacy-order-redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.6.4_0e13fd5257b8dba9d4e17f718301a864/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  legacy_45order_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}